import Cookies from "js-cookie";

const app = {
  state: {
    sidebar: {
      opened: false,
      isShowSidebarBtn: true,
      withoutAnimation: true
    },
    isShowFooter: false,
    device: "desktop",
    language: Cookies.get("language") || "en",
    size: Cookies.get("size") || "medium",
    menu: [],
    currentMenuArr: [],
    businessOpenShopStep: 1,
    tempStoreInfo: {},
    nameCheck: [
      {
        name: "准备资料",
        isActive: true
      },
      {
        name: "快速注册"
      },
      {
        name: "申请开店"
      },
      {
        name: "合同录入"
      },
      {
        name: "人工审核"
      }
    ],
    requestMessageHidden: ["qryBusinessInfo", "qryBusinessInfoByTyc"],
    currentComponent: "readyDataIndex",
    isShowDialogTimeout: false,
    reload: true,
    resultInfo: {},
    userRegisterInfo: {},
    loadingMessage: "加载中,请稍等...",
    pageLoading: {
      pageLoadingStatus: false,
      pageLoadingEnable: false
    },
    routerPower: {
      isShow: false,
      message: ""
    }
  },
  mutations: {
    SET_ROUTER_305: (state, routerPower) => {
      state.routerPower = routerPower;
    },
    SET_PAGELOADING: (state, status) => {
      state.pageLoading.pageLoadingStatus = status;
    },
    SET_PAGELOADINGENABLE: (state, status) => {
      state.pageLoading.pageLoadingEnable = status;
    },
    SET_LOADINGMESSAGE: (state, loadingMessage) => {
      state.loadingMessage = loadingMessage;
    },
    SET_IS_SHOW_DIALOG_TIMEOUT: (state, isShowDialogTimeout) => {
      state.isShowDialogTimeout = isShowDialogTimeout;
      console.log("adfasdfadf", state.isShowDialogTimeout);
    },
    RELOAD_SET: (state, restReload) => {
      state.reload = restReload;
    },
    BUSINESS_OPEN_SHOP_SET_STEP: (state, thisStepIdx) => {
      state.reload = false;
      state.businessOpenShopStep = thisStepIdx;
      state.nameCheck.forEach((item, idx) => {
        if (idx + 1 <= state.businessOpenShopStep) {
          item.isActive = true;
        } else {
          item.isActive = false;
        }
      });
      state.nameCheck = JSON.parse(JSON.stringify(state.nameCheck));
    },
    SAVE_TEMP_STORE_INFO: (state, stoteInfo) => {
      state.tempStoreInfo = stoteInfo
    },
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = true;
      if (state.sidebar.opened) {
        Cookies.set("sidebarStatus", 1);
      } else {
        Cookies.set("sidebarStatus", 0);
      }
    },
    OPEN_SIDEBAR_TEMPORARY: state => {
      state.sidebar.opened = true;
    },
    CLOSE_SIDEBAR_TEMPORARY: state => {
      state.sidebar.opened = false;
    },
    SHOW_SIDEBAR_BTN: state => {
      state.sidebar.isShowSidebarBtn = true;
    },
    HIDE_SIDEBAR_BTN: state => {
      state.sidebar.isShowSidebarBtn = false;
    },
    SHOW_FOOTER: state => {
      state.isShowFooter = true;
    },
    HIDE_FOOTER: state => {
      state.isShowFooter = false;
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set("sidebarStatus", 0);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language;
      Cookies.set("language", language);
    },
    SET_SIZE: (state, size) => {
      state.size = size;
      Cookies.set("size", size);
    },
    SET_MENU: (state, menu) => {
      state.menu = menu;
    },

    SET_CURRENT_MENU_ARR: (state, currentMenuArr) => {
      state.currentMenuArr = currentMenuArr;
    }
  },
  actions: {
    setRouter305: ({ commit }, routerPower) => {
      commit("SET_ROUTER_305", routerPower);
    },
    setPageLoading: ({ commit }, status) => {
      commit("SET_PAGELOADING", status);
    },
    setPageLoadingEnable: ({ commit }, status) => {
      commit("SET_PAGELOADINGENABLE", status);
    },
    businessOpenShopSetStep({ commit }, thisStepIdx) {
      commit("BUSINESS_OPEN_SHOP_SET_STEP", thisStepIdx);
    },
    saveTempStoreInfo({ commit }, stoteInfo) {
      commit("SAVE_TEMP_STORE_INFO", stoteInfo);
    },
    toggleSidebar({ commit }) {
      commit("TOGGLE_SIDEBAR");
    },
    closeSidebar({ commit }, { withoutAnimation }) {
      commit("CLOSE_SIDEBAR", withoutAnimation);
    },
    openSidebarTemporary({ commit }) {
      commit("OPEN_SIDEBAR_TEMPORARY");
    },
    closeSidebarTemporary({ commit }) {
      commit("CLOSE_SIDEBAR_TEMPORARY");
    },
    showSidebarBtn({ commit }) {
      commit("SHOW_SIDEBAR_BTN");
    },
    hideSidebarBtn({ commit }) {
      commit("HIDE_SIDEBAR_BTN");
    },
    showFooter({ commit }) {
      commit("SHOW_FOOTER");
    },
    hideFooter({ commit }) {
      commit("HIDE_FOOTER");
    },
    toggleDevice({ commit }, device) {
      commit("TOGGLE_DEVICE", device);
    },
    setLanguage({ commit }, language) {
      commit("SET_LANGUAGE", language);
    },
    setSize({ commit }, size) {
      commit("SET_SIZE", size);
    },
    setMenu({ commit }, menu) {
      commit("SET_MENU", menu);
    },
    setCurrentMenuArr({ commit }, currentMenuArr) {
      commit("SET_CURRENT_MENU_ARR", currentMenuArr);
    }
  }
};

export default app;
